//计算字符串长度，其中ascii码值是32-126的字符长度计为1，其他均为2
export default function length(str: string) {
  let len = 0
  for (let i = 0; i < str.length; i++) {
    if (isEnCharacter(str.charCodeAt(i))) {
      len += 1
    } else {
      len += 2
    }
  }
  return len
}

function isEnCharacter(char: number) {
  return char >= 32 && char <= 126
}
